import i18next from "i18next";
import resources from "../../../lang";
import Locale from './locale';

function initI18n() {
    const namespace = 'translation';
    const namespacedResources = {};

    for (const lang in resources) {
        namespacedResources[lang] = {
            translation: resources[lang],
        };
    }

    i18next.init({
        lng: Locale.getLocale() ?? Locale.getFallbackLocale(),
        fallbackLng: [ Locale.getDefaultLocale(), Locale.getFallbackLocale() ],
        debug: process.env.NODE_ENV === 'development',
        resources: namespacedResources,
        ns: namespace,
        defaultNS: namespace,
    });
}

$(function () {
    initI18n();
});
